import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  inputType,
  isValidArray,
} from "src/helper/publicFunction";
import {
  ManageSlideshow,
  DeleteSlideshow,
  EditSlideshow,
  GetSlideshow,
} from "./actions";
import DynamicModal from "src/components/modal/DynamicModal";
import * as Yup from "yup";
import { CommonAlert } from "src/components/alert/CommonAlert";

const Slideshow = () => {
  const dispatch = useDispatch();
  const Commonalert = CommonAlert();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [array, setarray] = useState([]);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  
  const privilegeId = "7"; 
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);
  
  const Schema = Yup.object().shape({
    title: Yup.string().trim().required("Title is required"),
    image: Yup.mixed().test(
      "image-required",
      "Image is required",
      function(value) {
        // If editing and image exists (string URL), it's valid
        if (editMode && value && typeof value === "string") {
          return true;
        }
        // If not editing, image is required
        if (!editMode) {
          return value !== null && value !== undefined && value !== "";
        }
        // If editing and no existing image, require new image
        return value !== null && value !== undefined && value !== "";
      }
    ),
  });

  const GetData = () => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetSlideshow({
        callback: (response) => {
          const responseData = response?.data;
          
          if (responseData && typeof responseData === 'object' && !Array.isArray(responseData)) {
            setData([responseData]);
            setTotalData(1);
          } else if (isValidArray(responseData)) {
            setData(responseData);
            setTotalData(responseData.length);
          } else {
            setData([]);
            setTotalData(0);
          }
          setLoadingData(false);
        },
      })
    );
    
    if (array.length === 0) {
      setarray([
        {
          failed: "id",
          type: inputType.text,
          title: "id",
          placeholder: "",
          fullwidth: true,
          customdesign: { display: "none" },
        },
        {
          failed: "title",
          type: inputType.text,
          title: "Title",
          placeholder: "Enter title",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "description",
          type: inputType.textarea,
          title: "Description",
          placeholder: "Enter description",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "button_text",
          type: inputType.text,
          title: "Button Text",
          placeholder: "Enter button text",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "button_url",
          type: inputType.text,
          title: "Button URL",
          placeholder: "Enter button URL",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "image",
          type: inputType.image,
          title: "Image",
          placeholder: "Upload image",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "display_order",
          type: inputType.number,
          title: "Display Order",
          placeholder: "Enter display order",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
        {
          failed: "is_active",
          type: inputType.checkbox,
          title: "Is Active",
          placeholder: "",
          fullwidth: true,
          customdesign: { width: "100%" },
        },
      ]);
    }
  };

  useEffect(() => {
    GetData();
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.text, name: "title" },
    { type: columntype.text, name: "description", isSmall: "true" },
    { type: columntype.text, name: "button_text" },
    { type: columntype.text, name: "button_url" },
    { 
      type: columntype.image, 
      name: "image",
      options: {
        width: 100,
        height: 100
      }
    },
    { type: columntype.text, name: "display_order" },
    { type: columntype.boolean, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "ID",
      withSort: true,
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      withSort: false,
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      withSort: false,
    },
    {
      id: "button_text",
      numeric: false,
      disablePadding: false,
      label: "Button Text",
      withSort: false,
    },
    {
      id: "button_url",
      numeric: false,
      disablePadding: false,
      label: "Button URL",
      withSort: false,
    },
    {
      id: "image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "display_order",
      numeric: false,
      disablePadding: false,
      label: "Display Order",
      withSort: false,
    },
    {
      id: "is_active",
      numeric: false,
      disablePadding: false,
      label: "Is Active",
      withSort: false,
    },
    (dataPrivileges[privilegeId]?.access_edit == 1 ||
      dataPrivileges[privilegeId]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Actions",
      withSort: false,
    },
  ];
  
  const List = [
    dataPrivileges[privilegeId]?.access_delete == 1 && {
      name: "Delete",
      function: async (row) => {
        if (row) {
          Commonalert.show({
            title: `Delete ${row?.title ?? "this item"}?`,
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSlideshow({
                      callback: () => GetData(),
                      id: [row?.id],
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }
      },
    },
    dataPrivileges[privilegeId]?.access_edit == 1 && {
      name: "Edit",
      function: async (data) => {
        setEditMode(true);
        // Preserve image URL when editing
        const editValues = {
          ...data,
          image_url: data.image || data.image_url, // Store original image URL
        };
        setvalues(editValues);
        setShowModal(true);
      },
    },
  ];

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditSlideshow({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
          GetData();
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => 
      prevData.map(item => 
        item.id === id ? {...item, [failedName]: newData} : item
      )
    );
    setloadingEditdatatype("");
  };

  return (
    <>
      <DynamicTable
        handleSearch={setSearch}
        onRequestSort={(tableName, type) => tableName && type && GetData({ tableName, type })}
        onPressDelete={(ListIds) => {
          Commonalert.show({
            title: "Confirm Delete",
            message: `Delete ${ListIds.length} item(s)?`,
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteSlideshow({
                      callback: () => GetData(),
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }}
        onPressItem={() => {}}
        onPressAnyAction={updateDataApi}
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }}
        items={data}
        columns={columns}
        headCells={headCells}
        page={page}
        setPage={setPage}
        selected={selected}
        setSelected={setSelected}
        search={search}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        Listdropdown={List}
        withOption={true}
        loadingData={loadingData}
        rowsPerPageOptions={[5, 10, 25, 50]}
        totalItem={TotalData}
        loadingEditdatatype={loadingEditdatatype}
        withAddButton={dataPrivileges[privilegeId]?.access_write == 1}
        withDeleteItem={dataPrivileges[privilegeId]?.access_delete == 1}
        withEditItem={dataPrivileges[privilegeId]?.access_edit == 1}
        withPagination={false}
        withSearch={false}
      />
      
      {showModal && (
        <DynamicModal
          show={showModal}
          setShow={setShowModal}
          faileds={array}
          values={values}
          title={"Slideshow"}
          editMode={editMode}
          description={editMode ? "Edit Slideshow" : "Add New Slideshow"}
          buttonTitle={editMode ? "Update" : "Create"}
          onSubmit={(values) => {
            dispatch(
              ManageSlideshow({
                editMode,
                values,
                callback: (res) => {
                  if (res) {
                    setShowModal(false);
                    GetData();
                  }
                },
              })
            );
          }}
          Schema={Schema}
        />
      )}
    </>
  );
};

export default Slideshow;